module.exports = __webpack_public_path__ + "img/26-r.e4d7cec4.png";